// 🔑 THE UNDERWRITING GUIDE IS SERVED ONLY TO SIGNED-IN, AUTHORIZED VIEWERS (Jesse, 2026-10-21).
// GET /api/uw-matrix (the full matrix), /api/uw-matrix/guide (the guide document) and /api/uw-matrix/afm-guidelines.pdf
// answer only a staff session, a partner with an approved agreement, or an approved DoorlyMarket investor
// (backend/middleware/guideAccess), or a guide pass from the password page. This sends whichever the viewer holds —
// each portal stores its own session — and tries the next if one is refused. No password in the bundle.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const TOKEN_KEYS = ['doorly_admin_token', 'doorlypro_token', 'doorly_investor_token'];
// 🔑 THE PASSWORD PAGE'S PASS (Jesse, 2026-10-22). POST /api/uw-matrix/unlock checks the password on the server and
// answers a 12-hour guide pass, kept for this tab only (sessionStorage, as the original page kept its "granted").
// It opens the guide, the Program Matrix and the PDF; the password itself is never stored or compared here.
const PASS_KEY = 'uw_guide_pass';
let memoryPass = null;   // when sessionStorage is unavailable

/** 'ok' | { error } — ask the server to check the password; on success the pass is kept for this tab. */
export async function unlockGuide(password) {
  try {
    const r = await fetch(`${API_URL}/api/uw-matrix/unlock`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password }) });
    const body = await r.json().catch(() => ({}));
    if (r.ok && body && body.token) {
      try { sessionStorage.setItem(PASS_KEY, body.token); } catch (_) { /* storage unavailable: this load only */ }
      memoryPass = body.token;
      return 'ok';
    }
    return { error: (body && body.error) || 'Incorrect password. Please try again.' };
  } catch (_) {
    return { error: 'Could not reach Doorly. Check your connection and try again.' };
  }
}

export function guideTokens() {
  const out = [];
  try { const p = sessionStorage.getItem(PASS_KEY) || memoryPass; if (p) out.push(p); } catch (_) { if (memoryPass) out.push(memoryPass); }
  for (const k of TOKEN_KEYS) {
    try { const t = localStorage.getItem(k); if (t) out.push(t); } catch (_) { /* storage unavailable */ }
  }
  return out;
}

/** { status: 200, data } | { status: 401 (not signed in) | 403 (not authorized; code 'NDA_REQUIRED' for an approved
 *  investor who has not signed the NDA) | 0 (network), code? } */
export async function fetchGuide(path, { as = 'json' } = {}) {
  const tokens = guideTokens();
  if (!tokens.length) return { status: 401 };
  let last = { status: 401 };
  for (const t of tokens) {
    try {
      const r = await fetch(`${API_URL}${path}`, { headers: { Authorization: `Bearer ${t}` } });
      if (r.ok) return { status: 200, data: as === 'blob' ? await r.blob() : await r.json() };
      const body = await r.json().catch(() => ({}));
      // An NDA prompt beats a plain refusal: keep it if any session answered it.
      if (!(last.code === 'NDA_REQUIRED')) last = { status: r.status, code: body && body.code };
    } catch (_) { if (!last.code) last = { status: 0 }; }
  }
  return last;
}

/** Open the AFM PDF in a new tab (the request carries the session, so it cannot be a plain link). */
export async function openAfmPdf() {
  const w = window.open('', '_blank');
  const r = await fetchGuide('/api/uw-matrix/afm-guidelines.pdf', { as: 'blob' });
  if (r.status !== 200) { if (w) w.close(); return r.status; }
  const url = URL.createObjectURL(r.data);
  if (w) w.location.href = url; else window.location.href = url;
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return 200;
}

export { API_URL };

